import AbstractStore from 'core/abstracts/AbstractStore';
import Dispatcher from 'core/Dispatcher';
import Constants from 'constants.js';

class PerformanceStore extends AbstractStore {

    constructor() {

        const CHANGE_EVENT = 'PERFORMANCE_CHANGE_EVENT';
        const NAME = 'PERFORMANCE_STORE';

        super(NAME, CHANGE_EVENT);

        this._initStore();

        // Registers action handler with the Dispatcher.
        Dispatcher.register(this._registerToActions.bind(this));
    }

    _initStore() {
        this.accounts = null;
        this.sites = [];
        this.loading = false;

        const from = new Date();
        const to = new Date();
        from.setMonth(from.getMonth() - 6);

        this.params = {
            from,
            to,
            search: '',
            bySites: false
        };
    }

    isLoading() {
        return this.loading;
    }

    getSites() {
        return this.sites;
    }

    getParams() {
        return this.params;
    }

    setParams(params) {
        this.params = params;
    }

    setSites(sites, accounts, bySites) {
        if (!bySites) {
            const account = accounts.find(a => a.name === this.params.search);
            // Keep only sites linked to current account
            const sitesNeeded = sites.filter(s => account.perfSiteIds.includes(s.id));
            this.sites = sitesNeeded;
        } else {
            this.sites = sites;
        }
    }

    setAccounts(accounts) {
        // Keep only the account needed
        const account = accounts.find(a => a.name === this.search);
        this.accounts = account;
    }

    updatePerformance(performance) {
        this.sites = this.sites.map(site => {
            if (site.id === performance.siteId) {
                site.records = site.records.map(record => {
                    let newRecord = record;
                    if (newRecord.id === performance.id) {
                        newRecord.date = performance.date.toISOString().slice(0, 10);
                        newRecord.orderCount = performance.orderCount;
                        newRecord = Object.assign({}, newRecord);
                    }

                    return newRecord;
                });
            }
            return site;
        });
    }

    addPerformance(performance) {
        this.sites = this.sites.map(site => {
            if (site.id === performance.siteId) {
                site.records.push({
                    date: performance.date.toISOString().slice(0, 10),
                    id: performance.id,
                    orderCount: performance.orderCount
                });
            }
            return site;
        });
    }

    deletePerformance(performanceId) {
        this.sites = this.sites.map(site => {
            site.records = site.records.filter(r => r.id !== performanceId);
            return site;
        });
    }

    // Switches over the action's type when an action is dispatched.
    _registerToActions(action) {
        switch (action.actionType) {
        case Constants.LOGOUT:
            this._initStore();
            this._emitChange();
            break;
        case Constants.PERFORMANCES_GET_START:
            this.setParams(action.value);
            this.loading = true;
            this._emitChange();
            break;
        case Constants.PERFORMANCES_GET_END:
            this.loading = false;
            this.params.bySites = action.value.bySites;
            this.setAccounts(action.value.data.accounts);
            this.setSites(action.value.data.sites, action.value.data.accounts, action.value.bySites);
            this._emitChange();
            break;
        case Constants.PERFORMANCE_ADDED:
            this.addPerformance(action.value);
            this._emitChange();
            break;
        case Constants.PERFORMANCE_UPDATED:
            this.updatePerformance(action.value);
            this._emitChange();
            break;
        case Constants.PERFORMANCE_DELETED:
            this.deletePerformance(action.value);
            this._emitChange();
            break;
        default:
            return false;
        }
    }
}

export default new PerformanceStore();
